'use client';
import React, { useState } from 'react';
import Link from 'next/link';
import AppLogo from '@/components/ui/AppLogo';
import { Menu, X, ShieldCheck } from 'lucide-react';

export default function PublicHeader() {
  const [mobileOpen, setMobileOpen] = useState(false);

  return (
    <header className="sticky top-0 z-50 bg-white/90 backdrop-blur-md border-b border-border shadow-sm">
      <div className="max-w-screen-2xl mx-auto px-4 lg:px-8 xl:px-10 h-16 flex items-center justify-between">
        <Link href="/" className="flex items-center gap-2 group">
          <AppLogo size={36} />
          <span className="font-sans text-xl font-700 text-foreground tracking-tight">
            Make Me <span className="text-primary">Authentic</span>
          </span>
        </Link>

        <div className="hidden md:flex items-center gap-3">
          <Link
            href="/sign-up-login-screen"
            className="px-4 py-2 rounded-lg text-sm font-semibold bg-primary text-primary-foreground hover:bg-primary/90 active:scale-95 transition-all duration-150 flex items-center gap-2"
          >
            <ShieldCheck size={16} />
            Admin Login
          </Link>
        </div>

        <button
          onClick={() => setMobileOpen(!mobileOpen)}
          className="md:hidden p-2 rounded-lg hover:bg-muted transition-colors"
          aria-label="Toggle navigation"
        >
          {mobileOpen ? <X size={20} /> : <Menu size={20} />}
        </button>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-white border-t border-border px-4 py-3 flex flex-col gap-1">
          <Link href="/sign-up-login-screen" className="mt-2 px-3 py-2 rounded-lg text-sm font-semibold bg-primary text-primary-foreground text-center" onClick={() => setMobileOpen(false)}>Admin Login</Link>
        </div>
      )}
    </header>
  );
}